const ProjectIcon = ({ classes, color }) => {
    return (
        <svg width="7" height="7" viewBox="0 0 7 7" fill={ color ? color : '#595959' } xmlns="http://www.w3.org/2000/svg" style={{ maxHeight: '100%', margin: '0 6px 2px 2px' }}>
            <circle cx="3.5" cy="3.5" r="3.5" />
        </svg>
    ); 
}

export default ProjectIcon;